"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginConfig = void 0;
const PhoneEmailInputScreenIcon = 'https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/phone-screen-icon.svg';
const EnterOTPScreenIcon = 'https://central-frontend-prod.ackoassets.com/_next_static/images/building-block-assets/otp-screen-icon.svg';
const AckoLogo = 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/gradient-horizontal.svg';
exports.LoginConfig = {
    default: {
        phoneEmailInputScreenIcon: AckoLogo,
        otpInputScreenIcon: EnterOTPScreenIcon,
        title: 'Log in with your phone number',
        account_recovery: true,
        account_recovery_text: 'Can’t access?',
        account_recovery_link_text: 'Recover my account',
        account_recovery_url: '/account-recovery',
    },
    challan_widget_new_flow: {
        title: 'Verify your mobile number to confirm your identity',
        subTitle: 'We need this to keep your challan details secure',
        login_button_text: 'Get OTP',
    },
    challan_widget: {
        title: 'Verify your number to view all your pending challans',
        login_button_text: 'Continue',
    },
    fastag_widget: {
        title: 'Verify your number to view your FASTag balance',
        login_button_text: 'Continue',
    },
    seo_widget: {
        title: '',
        login_button_text: 'Verify',
    },
    RTO_widget: {
        title: 'Verify your number to view vehicle details',
        login_button_text: 'Continue',
    },
    RTO_Detail_widget: {
        title: 'Verify your number to view RTO details',
        login_button_text: 'Continue',
    },
    PUC_widget: {
        title: 'Verify your number to view your PUC details',
        login_button_text: 'Continue',
    },
    health_prequote_modal_mobile: {
        phoneEmailInputScreenIcon: PhoneEmailInputScreenIcon,
        otpInputScreenIcon: EnterOTPScreenIcon,
        title: 'Verify your number to view plans customised for your family',
        login_button_text: 'Continue',
    },
    health_prequote_modal_desktop: {
        phoneEmailInputScreenIcon: PhoneEmailInputScreenIcon,
        otpInputScreenIcon: EnterOTPScreenIcon,
        title: 'Verify your number to view plans customised for your family',
        login_button_text: 'Get OTP',
    },
    health_prequote_full_page_mobile: {
        title: 'Verify your number to view plans customised for your family',
        login_button_text: 'Continue',
    },
    health_prequote_full_page_desktop: {
        title: 'Verify your number to view plans customised for your family',
        login_button_text: 'Get OTP',
    },
    health_postquote_modal: {
        phoneEmailInputScreenIcon: 'url',
        title: 'Login with your phone number to continue',
    },
    health_postquote_fullPage: {
        title: 'Login with your phone number to continue',
    },
    auto_modal: {
        phoneEmailInputScreenIcon: PhoneEmailInputScreenIcon,
        otpInputScreenIcon: EnterOTPScreenIcon,
        title: 'Verify your phone number to continue',
    },
    auto_fullPage: {
        title: 'Verify your phone number to continue',
    },
    connect_corporate_email_modal: {
        phoneEmailInputScreenIcon: PhoneEmailInputScreenIcon,
        otpInputScreenIcon: EnterOTPScreenIcon,
        title: 'Connect your corporate email address to automatically retrieve family and policy details',
        type: 'email',
    },
    connect_corporate_email_fullPage: {
        title: 'Connect your corporate email address to automatically retrieve family and policy details',
        type: 'email',
    },
    health: {
        title: 'Verify your phone number',
        login_button_text: 'Get OTP',
        phoneEmailInputScreenIcon: AckoLogo,
        otpInputScreenIcon: EnterOTPScreenIcon,
        account_recovery: true,
        account_recovery_text: 'Can’t access?',
        account_recovery_link_text: 'Recover my account',
        account_recovery_url: '/account-recovery',
        hideBannerImage: true,
        hideLandingImage: true,
    },
};
//# sourceMappingURL=dummy.js.map